module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/dashboard/dashboard-screen/dashboard-screen.component.scss
// module id = ./libs/atenea-cms-brand/src/dashboard/dashboard-screen/dashboard-screen.component.scss
// module chunks = main